import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSnackBar, MatTableDataSource, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { GatewayService } from '../../gateway.service';
import { LocalSaveService } from '../../services/local-save-service.service';
import { DlgCapturarCoordsComponent } from './dlg-capturar-coords/dlg-capturar-coords.component';

const SUPERVISOR_IDROLES = [1, 3, 10, 15, 16];

@Component({
    selector: 'app-citasprogramadas-sin-coordenadas',
    templateUrl: './citasprogramadas-sin-coordenadas.component.html',
    styleUrls: ['./citasprogramadas-sin-coordenadas.component.scss']
})
export class CitasprogramadasSinCoordenadasComponent implements OnInit {

    displayedColumns = ['prioridad', 'falla', 'cliente', 'direccion', 'ubicacion', 'fechaBanda', 'tecnico', 'accion'];
    dataSource = new MatTableDataSource<any>([]);
    total = 0;
    page = 1;
    pageSize = 50;
    isLoading = false;

    fechaDesde: string | null = null;
    fechaHasta: string | null = null;
    contratasSel: number[] = [];
    id_provincia: number | null = null;
    id_distrito: number | null = null;
    id_prioridad: number | null = null;
    search = '';

    contratas: any[] = [];
    provincias: any[] = [];
    distritos: any[] = [];
    prioridades: any[] = [];

    puedeVer = false;

    @ViewChild(MatPaginator, { static: false } as any) paginator: MatPaginator;

    constructor(
        private gateway: GatewayService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private router: Router,
        private localSave: LocalSaveService
    ) {}

    private _tienePermiso(modulo: string): boolean {
        const user = this.localSave.get('usuarioPGV');
        if (!user || !user.permisos) return false;
        const perm = user.permisos.find((p: any) => p.modulo === modulo);
        return !!(perm && perm.permiso_ver === 1);
    }

    ngOnInit(): void {
        const user = this.localSave.get('usuarioPGV');
        const esSuperAdmin = user && user.esSuperAdmin;
        const esRolSupervisor = user && SUPERVISOR_IDROLES.includes(Number(user.idrol));
        this.puedeVer = esSuperAdmin || esRolSupervisor || this._tienePermiso('CITAS_SIN_COORDENADAS');

        if (!this.puedeVer) {
            this.router.navigate(['/home']);
            return;
        }

        // Default de fechas: hoy -> manana
        const def = this._defaultRangoFechas();
        this.fechaDesde = def.desde;
        this.fechaHasta = def.hasta;

        this.gateway.get('getprovincias', {}).then((r: any) => this.provincias = (r && r.rows) ? r.rows : []).catch(() => {});
        this.gateway.get('getcontratasperm',  {}).then((r: any) => this.contratas  = (r && r.rows) ? r.rows : []).catch(() => {});
        this.gateway.get('getprioridades',  {}).then((r: any) => this.prioridades = (r && r.rows) ? r.rows : []).catch(() => {});

        this.cargar();
    }

    private _defaultRangoFechas(): { desde: string, hasta: string } {
        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        const fmt = (d: Date) => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
        const hoy = new Date();
        const manana = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 1);
        return { desde: fmt(hoy), hasta: fmt(manana) };
    }

    onProvinciaChange(): void {
        this.id_distrito = null;
        this.distritos = [];
        if (this.id_provincia != null) {
            this.gateway.get('getdistritosxprovincia', { idprovincia: this.id_provincia })
                .then((r: any) => this.distritos = (r && r.rows) ? r.rows : [])
                .catch(() => {});
        }
    }

    cargar(): void {
        this.isLoading = true;
        const body = {
            page: this.page,
            pageSize: this.pageSize,
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
            id_contrata: this.contratasSel,
            id_provincia: this.id_provincia,
            id_distrito: this.id_distrito,
            id_prioridad: this.id_prioridad,
            search: this.search
        };
        this.gateway.get('listarCitasSinCoordenadas', body).then((r: any) => {
            this.dataSource.data = (r && r.rows) ? r.rows : [];
            this.total = (r && typeof r.total === 'number') ? r.total : 0;
        }).catch(() => {
            this.dataSource.data = [];
            this.total = 0;
        }).then(() => {
            this.isLoading = false;
        });
    }

    aplicarFiltros(): void {
        this.page = 1;
        if (this.paginator) this.paginator.firstPage();
        this.cargar();
    }

    limpiarFiltros(): void {
        // "Limpiar" vuelve a los valores por defecto: rango hoy -> manana
        const def = this._defaultRangoFechas();
        this.fechaDesde = def.desde;
        this.fechaHasta = def.hasta;
        this.contratasSel = [];
        this.id_provincia = null;
        this.id_distrito = null;
        this.distritos = [];
        this.id_prioridad = null;
        this.search = '';
        this.aplicarFiltros();
    }

    onPage(ev: PageEvent): void {
        this.page = ev.pageIndex + 1;
        this.pageSize = ev.pageSize;
        this.cargar();
    }

    abrirCaptura(row: any): void {
        const ref = this.dialog.open(DlgCapturarCoordsComponent, {
            width: '480px',
            data: { cita: row }
        });
        ref.afterClosed().subscribe((result: any) => {
            if (!result) return;
            this.guardarCoords(row, result.latitud, result.longitud);
        });
    }

    private guardarCoords(row: any, latitud: string, longitud: string): void {
        const user = this.localSave.get('usuarioPGV');
        const idUsuario = user ? user.idagente : null;

        this.gateway.get('capturarCoordsCita', {
            id_cita:  row.id,
            latitud:  latitud,
            longitud: longitud,
            id_usuario: idUsuario
        }).then((r: any) => {
            if (r && r.response === 1) {
                this.snackBar.open('Coordenadas guardadas', 'OK', { duration: 3000 });
                this.cargar();
            } else {
                this.snackBar.open((r && r.message) ? r.message : 'No se pudieron guardar', 'OK', { duration: 4000 });
            }
        }).catch(() => {
            this.snackBar.open('Error al guardar coordenadas', 'OK', { duration: 4000 });
        });
    }

    getPrioridadColor(idprio: number): string {
        switch (Number(idprio)) {
            case 1: return '#d32f2f';
            case 2: return '#f57c00';
            case 3: return '#fbc02d';
            case 4: return '#388e3c';
            default: return '#90a4ae';
        }
    }
}
